// Tipos relacionados ao schema do banco de dados
export interface DbSchemaColumn {
  table_name: string;
  column_name: string;
  ordinal_position: number;
  data_type: string;
  character_maximum_length: number | null;
  is_nullable: 'YES' | 'NO';
  column_default: string | null;
  isPrimaryKey?: boolean;
  isUnique?: boolean;
}

export interface ProcessedSchema {
  [tableName: string]: DbSchemaColumn[];
}

// Tipos relacionados ao mapeamento de colunas
export interface ColumnMapping {
  [csvHeader: string]: string; // csvHeader -> dbColumnName
}

// Tipos relacionados à visualização (preview)
export enum PreviewStatus {
  New = 'Novo',
  Update = 'Atualizar',
  Identical = 'Idêntico',
  Error = 'Erro',
  Skipped = 'Ignorado' // Adicionado para linhas sem identificador
}

export interface PreviewRow {
  id: string | number;
  status: PreviewStatus;
  csvData: { [key: string]: any };
  dbData?: { [key: string]: any } | null;
  changes?: { [dbColumn: string]: { oldValue: any; newValue: any } };
  error?: string;
}

// Type for the mapping confirmation section
export interface MappedColumnInfo {
  csvColumn: string;
  dbColumn: string | null;
  isIdentifier: boolean;
}

// Tipo para os dados parseados do CSV
export interface CsvRowData {
  [header: string]: string | number | boolean | null | undefined;
} 